// src/router/centroCusto.js

// Quem abre estas telas (TRI-107; o admin passa). Aplicado pelo guard de @/router/permissoes.js,
// que o menu lateral também usa.
const ROLES = ['peopleCulture']

const breadCrumb = [
    {
        label: 'Home',
        to: 'Home'
    },
    {
        label: 'Centro de custos',
        to: 'CentroCustoList'
    }
]

export default [
    {
        path: '/centro-custo',
        name: 'CentroCustoList',
        component: () => import('@/views/CentroCusto/ListPage.vue'),
        meta: {
            roles: ROLES,
            title: 'Centro de custos',
            breadcrumb: breadCrumb
        },
    },
    {
        path: '/centro-custo/novo',
        name: 'NovoCentroCusto',
        component: () => import('@/views/CentroCusto/NovoPage.vue'),
        meta: {
            roles: ROLES,
            title: 'Novo Centro de Custo',
            breadcrumb: [
                ...breadCrumb,
                {
                    label: 'Novo Centro de Custo',
                    to: 'NovoCentroCusto'
                }
            ]
        }
    },
    {
        path: '/centro-custo/:id/edit',
        name: 'NovoCentroCustoEdit',
        component: () => import('@/views/CentroCusto/NovoPage.vue'),
        meta: {
            roles: ROLES,
            title: 'Detalhes do Centro de custo',
            breadcrumb: [
                ...breadCrumb,
                {
                    label: 'Detalhes do Centro de custo',
                    to: 'NovoCentroCusto'
                }
            ]
        }
    }
];
